import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import "./i18n.ts"

import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/store.ts'

createRoot(document.getElementById('root')!).render(
    // <StrictMode>
    <Provider store={store}>
        <Suspense fallback={<></>}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Suspense>
    </Provider>
    // </StrictMode>,
)
